export const SET_PRINTQUEUE_USERS = 'SET_PRINTQUEUE_USERS';
export const SET_PRINTQUEUE_TYPES = 'SET_PRINTQUEUE_TYPES';
export const SET_PRINTQUEUE_RETURN_METHOD = 'SET_PRINTQUEUE_RETURN_METHOD';
export const SET_PRINTQUEUE_DATA = 'SET_PRINTQUEUE_DATA';

export const initialState = {
  users: [],
  types: [],
  returnMethods: [],
  printQueueData: [],
  printQueueTotalCount: 0,
}

const WorkviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRINTQUEUE_USERS:
      return {
        ...state,
        users: action.users,
      }
    case SET_PRINTQUEUE_TYPES:
      return {
        ...state,
        types: action.types,
      }
    case SET_PRINTQUEUE_RETURN_METHOD:
      return {
        ...state,
        returnMethods: action.returnMethods,
      }
    case SET_PRINTQUEUE_DATA:
      return {
        ...state,
        printQueueData: action.printQueueData,
        printQueueTotalCount: action.totalCount,
      }
    default:
      return state
  }
}

export default WorkviewReducer;